import { ModalMode, Season, SeasonDateWithCode, SeasonEventSelection, SeasonsState } from '@/views/seasons/seasons.types';
import { clearCalendarDayCode }                                                      from '@/views/seasons/helpers/season.helpers';

const mutations = {
  addSeasons(state: SeasonsState, seasons: Season[]): void {
    state.seasons = seasons;
  },
  addSeason(state: SeasonsState, season: Season): void {
    state.seasons.push({
      ...season,
    });
  },
  toggleModal(state: SeasonsState, payload: boolean): void {
    state.modal.open = payload;
  },
  setModalMode(state: SeasonsState, mode: ModalMode): void {
    state.modal.mode = mode;
  },
  setFields(state: SeasonsState, season: Season): void {
    state.modal.form.originalFields = season;
  },
  updateForm(state: SeasonsState, payload: Partial<Season>): void {
    state.modal.form.originalFields = Object.assign(state.modal.form.originalFields, payload);
  },
  removeSeason(state: SeasonsState, code: string): void {
    state.seasons = state.seasons.filter((season: Season) => season.code !== code);
    clearCalendarDayCode(state.calendar, code);
  },
  setLoading(state: SeasonsState, payload: boolean): void {
    state.loading = payload;
  },
  setSeasonCode(state: SeasonsState, payload: string): void {
    state.selection.seasonCode = payload;
  },
  updateCalendar(state: SeasonsState, seasonDate: SeasonDateWithCode): void {
    state.calendar[ seasonDate.month ][ seasonDate.day ] = seasonDate.code;
  },
  updateSelection(state: SeasonsState, selection: Partial<SeasonEventSelection>): void {
    state.selection = Object.assign(state.selection, selection);
  },
};

export default mutations;
